'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (input) {
  return input.replace(/(\d)-(\d)/gim, '$1–$2');
};

module.exports = exports['default'];

